// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__cCYLZ","title":"Info_title__bd-1J","links":"Info_links__2KvoC","link":"Info_link__3QWyL","logo":"Info_logo__2NxFq"};